import axios from 'axios'

export const getPartnerList = () => {
  return axios
    .get('/data/sadarbības_partneru_saraksts')
    .then((res) => res.data)
    .catch(() => undefined)
}
